import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShieldCheck, MessageCircle } from "lucide-react";
import { formatDistanceToNow } from "date-fns";
import { fr } from "date-fns/locale";

/**
 * Read-only page for messages sent by Forum CI admins to the current user.
 * No reply UI — by design (Phase 6).
 */
export default function Messages() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin-messages");
      setItems(data || []);
      // Auto-mark all as viewed (Phase 10 'seen' tracking)
      for (const m of data || []) {
        if (!m.viewed) {
          api.post(`/admin-messages/${m.id}/view`).catch(() => {});
        }
      }
    } catch {}
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="max-w-2xl mx-auto px-3 sm:px-6 py-4">
      <h1 className="font-[Manrope] font-extrabold text-2xl flex items-center gap-2">
        <MessageCircle className="h-6 w-6 text-[#E65100]" /> Messages Forum CI
      </h1>
      <div className="text-sm text-[#73706B] mt-1">Communications officielles de l'équipe Forum CI. Vous ne pouvez pas répondre directement à ces messages.</div>

      {loading && <div className="py-10 text-center text-sm text-[#73706B]">Chargement…</div>}

      {!loading && items.length === 0 && (
        <div className="mt-6 py-12 text-center text-sm text-[#73706B] rounded-2xl border border-dashed border-[#E8E6E1]">
          Aucun message pour le moment.
        </div>
      )}

      <div className="mt-4 space-y-3">
        {items.map((m) => (
          <div key={m.id} data-testid={`admin-message-${m.id}`} className="p-4 rounded-2xl bg-white border border-[#E8E6E1] shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#E65100] to-[#C44100] text-white font-extrabold flex items-center justify-center">F</div>
              <div className="flex-1 min-w-0">
                <div className="font-bold text-sm flex items-center gap-1">
                  Forum CI <ShieldCheck className="h-4 w-4 text-[#0A7D3A]" />
                </div>
                <div className="text-[11px] text-[#73706B]">{relTime(m.created_at)}</div>
              </div>
            </div>
            <div className="mt-3 text-sm text-[#1A1918] whitespace-pre-line">{m.body}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function relTime(iso) {
  if (!iso) return "";
  try { return formatDistanceToNow(new Date(iso), { addSuffix: true, locale: fr }); } catch { return ""; }
}
